var map = {
	"./about-us-banner-cn.webp": 1548,
	"./about-us-banner-m-cn.webp": 1549,
	"./about-us-banner-m-ms.webp": 1550,
	"./about-us-banner-m.webp": 1551,
	"./about-us-banner-ms.webp": 1552,
	"./about-us-banner.webp": 464,
	"./banner-01.jpg": 1553,
	"./banner-slot.jpg": 1554,
	"./bet-and-earn-banner-cn.webp": 1555,
	"./bet-and-earn-banner-indon.webp": 1556,
	"./bet-and-earn-banner-ms.webp": 1557,
	"./bet-and-earn-banner.webp": 1558,
	"./check-in-banner-cn.webp": 1559,
	"./check-in-banner-id.webp": 1560,
	"./check-in-banner-ms.webp": 1561,
	"./check-in-banner.webp": 1562,
	"./cny_2024-bm.webp": 1563,
	"./cny_2024-cn.webp": 1564,
	"./cny_2024.webp": 1565,
	"./epl-banner-cn.webp": 1566,
	"./epl-banner-indo.webp": 1567,
	"./epl-banner-ms.webp": 1568,
	"./epl-banner.webp": 1569,
	"./games-banners-cn.webp": 1570,
	"./games-banners-ms.webp": 1571,
	"./games-banners.webp": 1572,
	"./lb-m-banner-cn.webp": 1573,
	"./lb-m-banner.webp": 1574,
	"./leaderboard-banner-cn.webp": 1575,
	"./leaderboard-banner.webp": 1576,
	"./lottery-banner.webp": 1577,
	"./lottery-banners-cn.webp": 1578,
	"./lottery-banners-ms.webp": 1579,
	"./lottery-banners.webp": 1580,
	"./lucky-spin-banner-cn.webp": 1581,
	"./lucky-spin-banner-ms.webp": 1582,
	"./lucky-spin-banner.webp": 1583,
	"./p2p-banner.webp": 1584,
	"./p2p-banners-cn.webp": 1585,
	"./p2p-banners-ms.webp": 1586,
	"./p2p-banners.webp": 1587,
	"./premier-league-banner-cn.webp": 1588,
	"./premier-league-banner.webp": 1589,
	"./promo-vip-banner-cn.webp": 1590,
	"./promo-vip-banner-ms.webp": 1591,
	"./promo-vip-banner.webp": 1592,
	"./promos-banner-cn.webp": 1593,
	"./promos-banner-indon.webp": 1594,
	"./promos-banner-ms.webp": 1595,
	"./promos-banner.webp": 1596,
	"./promos-detail-banner.jpg": 1597,
	"./side-bar-banner.jpg": 1598,
	"./slot-banners-cn.webp": 1599,
	"./slot-banners-ms.webp": 1600,
	"./slot-banners.webp": 1601,
	"./speed-banners-cn.webp": 1602,
	"./speed-banners-ms.webp": 1603,
	"./speed-banners.webp": 1604,
	"./vip-banner-cn.webp": 1605,
	"./vip-banner-id.webp": 1606,
	"./vip-banner-m-cn.webp": 1607,
	"./vip-banner-m-ms.webp": 1608,
	"./vip-banner-m.webp": 1609,
	"./vip-banner-ms.webp": 1610,
	"./vip-banner.webp": 1611,
	"./vip-deposit-marathon-challenges-cn.webp": 1612,
	"./vip-deposit-marathon-challenges-ms.webp": 1613,
	"./vip-deposit-marathon-challenges.webp": 1614,
	"./winner-leaderboard-banner-cn.webp": 1615,
	"./winner-leaderboard-banner.webp": 1616,
	"./world-cup-banner-cn.webp": 1617,
	"./world-cup-banner.webp": 1618,
	"./world-cup-two-banner-cn.webp": 1619,
	"./world-cup-two-banner.webp": 1620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;